module.exports = __webpack_public_path__ + "img/839-f5fd63.png";